import React, { useEffect } from "react";
import "./GridBackground.css";

export default function GridBackground() {
  useEffect(() => {
    const CONFIG = {
      squareSize: 50, // must match CSS
      animationDuration: 700,
      autoSlideOutDelay: 300, // ms
      colors: [
    "#0D47A1", // dark blue
    "#0B3D91", // deep royal blue
    "#003366", // midnight blue
    "#1976D2", // medium blue
    "#1E88E5", // vivid blue
    "#2196F3", // standard blue
    "#5E92F3", // soft mid blue
    "#42A5F5", // light blue
    "#64B5F6"  // sky blue
],
    };

    const utils = {
      getRandomColor: () =>
        CONFIG.colors[Math.floor(Math.random() * CONFIG.colors.length)],
    };

    function createGrid() {
      const container = document.getElementById("grid-container");
      if (!container) return;
      container.innerHTML = "";

      const cols = Math.ceil(window.innerWidth / CONFIG.squareSize);
      const rows = Math.ceil(window.innerHeight / CONFIG.squareSize);
      const totalSquares = cols * rows;

      for (let i = 0; i < totalSquares; i++) {
        const square = document.createElement("div");
        square.className = "grid-square";
        square.style.setProperty("--block-color", utils.getRandomColor());

        // Hover → glow → auto slide out
        square.addEventListener("mouseenter", () => {
          square.classList.remove("sliding-out", "showing");
          square.classList.add("sliding-in");

          setTimeout(() => {
            square.classList.remove("sliding-in");
            square.classList.add("showing");

            setTimeout(() => {
              square.classList.remove("showing");
              square.classList.add("sliding-out");
              setTimeout(() => {
                square.classList.remove("sliding-out");
              }, CONFIG.animationDuration);
            }, CONFIG.autoSlideOutDelay);
          }, CONFIG.animationDuration);
        });

        container.appendChild(square);
      }
    }

    createGrid();
    window.addEventListener("resize", createGrid);
    return () => window.removeEventListener("resize", createGrid);
  }, []);

  return <div className="grid-container" id="grid-container"></div>;
}
